import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const QuoteIcon = React.memo(function QuoteIcon(props: TQuoteIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Quote" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.75 4.5C3.47386 4.5 3.25 4.76456 3.25 5.09091V16.9091C3.25 17.2354 3.47386 17.5 3.75 17.5H4.25C4.52614 17.5 4.75 17.2354 4.75 16.9091V5.09091C4.75 4.76456 4.52614 4.5 4.25 4.5H3.75ZM8.25 5.75C7.97386 5.75 7.75 5.97386 7.75 6.25V6.75C7.75 7.02614 7.97386 7.25 8.25 7.25H15.25C15.5261 7.25 15.75 7.02614 15.75 6.75V6.25C15.75 5.97386 15.5261 5.75 15.25 5.75H8.25ZM8.25 10.25C7.97386 10.25 7.75 10.4739 7.75 10.75V11.25C7.75 11.5261 7.97386 11.75 8.25 11.75H18.25C18.5261 11.75 18.75 11.5261 18.75 11.25V10.75C18.75 10.4739 18.5261 10.25 18.25 10.25H8.25ZM7.75 15.25C7.75 14.9739 7.97386 14.75 8.25 14.75H13.25C13.5261 14.75 13.75 14.9739 13.75 15.25V15.75C13.75 16.0261 13.5261 16.25 13.25 16.25H8.25C7.97386 16.25 7.75 16.0261 7.75 15.75V15.25Z"
            />
        </IconBase>
    );
});

export default QuoteIcon;

// #region Types

export type TQuoteIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <QuoteIcon /> : { ...IconBaseExample, render: QuoteIcon };

// #endregion
